// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3g0NW","form":"style_form__2vrI2","enterMethod":"style_enterMethod__2nbWg","error":"style_error__3glOt"};